import { useMultiStepContext } from 'context/multi-step';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { recoverySelector } from 'slices';
import { doAskCode, doGetMethod, updateUsername } from 'slices/recovery';

export function useGetMethod() {
    const { step1Done, username, recoveryError, availableMethods } =
        useSelector(recoverySelector);
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm();
    const { setStep, cancelStep } = useMultiStepContext();
    const { i18n } = useTranslation();

    //check if only 1 method to set next Step
    useEffect(() => {
        if (availableMethods) {
            if (availableMethods.length === 1) {
                dispatch(
                    doAskCode({
                        username: username,
                        method: availableMethods[0],
                        language: i18n.language,
                    })
                );

                //Skip selection method if has only one
                setStep('step3');
            } else {
                setStep('step2');
            }
        }
    }, [availableMethods, dispatch, setStep, step1Done, username, i18n]);

    // On Input Login Change
    const onInputLoginChange = (val) => {
        dispatch(updateUsername(val));
    };

    // Handle on submit
    const onSubmit = handleSubmit(() => {
        dispatch(
            doGetMethod({
                username: username,
            })
        );
    });

    return {
        onSubmit,
        onInputLoginChange,
        register,
        recoveryError,
        cancelStep,
    };
}
